export default [
  {
    title: 'Homepage',
    route: 'chart',
    icon: 'PieChartIcon',
    roles: ['admin', 'owner'],
  },
  // {
  //   title: 'WIP',
  //   route: 'wip',
  //   icon: 'BriefcaseIcon',
  // },
  // {
  //   title: 'Editorial',
  //   route: 'editorial',
  //   icon: 'ArchiveIcon',
  // },
  // {
  //   title: 'Stat Website',
  //   route: 'stat_website',
  //   icon: 'BarChart2Icon',
  // },
  {
    title: 'Partner',
    route: 'partner',
    icon: 'UsersIcon',
    roles: ['admin'],
  },
  {
    title: 'Post Category',
    route: 'post_category',
    icon: 'BarChart2Icon',
    roles: ['admin', 'owner'],
  },
  {
    title: 'User',
    route: 'user',
    icon: 'UserIcon',
    roles: ['admin', 'owner'],
  },
  {
    title: 'Posts',
    route: 'posts',
    icon: 'PaperclipIcon',
    roles: ['admin', 'owner', 'editor', 'contributor'],
  },
  {
    title: 'Navbar',
    route: 'navbar',
    icon: 'LayoutIcon',
    roles: ['admin', 'owner'],
  },
  // {
  //   title: 'Navbar Mapping',
  //   route: 'navbar.mapping',
  //   icon: 'LayoutIcon',
  //   roles: ['admin', 'owner'],
  // },
  {
    title: 'Footer',
    route: 'footer',
    icon: 'TrelloIcon',
    roles: ['admin', 'owner'],
  },
  {
    title: 'Pages',
    route: 'pages',
    icon: 'HardDriveIcon',
    roles: ['admin', 'owner'],
  },
  {
    title: 'Banner Management',
    route: 'banner',
    icon: 'CastIcon',
    roles: ['admin', 'owner'],
  },
  {
    title: 'Settings',
    route: 'settings',
    icon: 'SettingsIcon',
    roles: ['owner'],
  },
];
